import { IKnm248 } from 'APIPackage/KnmModule/interfaces/IKnm248';
import { deleteObjectProperties } from 'CorePackage/MainModule/common/deleteObjectProperties';
import { convertFormDateValueToKnmDataDate } from 'KnmPackage/MainModule/common/convertFormDateValueToKnmDataDate';

import { convertKnmDocumentAttachmentsFormValuesToKnmData } from '../../../KnmPackage/MainModule/common/convertKnmDocumentAttachmentsFormValuesToKnmData';
import { IKnmErknmFormReason } from '../interfaces/IKnmErknmFormReason';
import { IKnmErpFormErvkReason } from '../../../KnmErpPackage/KnmErpApproveInfoModule/interfaces/IKnmErpFormErvkReason';
import { handleReactQuillDeltaValue } from '../../../functions/handleReactQuillDeltaValue';

export const convertReasonsFormValueToKnmData = (
  reasons: IKnmErknmFormReason[] | IKnmErpFormErvkReason[] | undefined,
): IKnm248['reasons'] => {
  if (!reasons) {
    return null;
  }

  return reasons.map(item => ({
    reason: {
      id: item.reason?.id || null,
      guid: item.reason?.guid || null,
      ervkUuid: item.ervkUuid || item.type?.ervkUuid || null,
      title: item.reason?.title || item.type?.title || null,
      shortTitle: item.reason?.shortTitle || item.type?.shortTitle || null,
      type: item.type ? deleteObjectProperties(item.type, ['label', 'value']) : null,
      text: item.text || null,
      textReactQuillEditor: handleReactQuillDeltaValue(item.textReactQuillEditor || item.text || null),
      date: convertFormDateValueToKnmDataDate(item.date),
      passportLinks: item?.passportLinks || null,
      videoFixations:
        item?.violationEvidences?.map(evi => ({
          guid: evi?.guid || null,
          dateVideo: convertFormDateValueToKnmDataDate(evi.date),
          descVideo: evi.description,
          linkVideo: evi.link,
          originPassportId: evi.originPassportId,
        })) || null,
      main: item.reason?.main || null,
      approveRequired: item.reason?.approveRequired || null,
      assignmentNumber: item.assignmentNumber || null,
      assignmentDate: convertFormDateValueToKnmDataDate(item.assignmentDate),
      requirementDetails: item.requirementDetails || null,
      dateRequirement: convertFormDateValueToKnmDataDate(item.dateRequirement),
      dateCreate: item.reason?.dateCreate || null,
      dateBegin: convertFormDateValueToKnmDataDate(item.dateBegin || item.type?.dateBegin),
      dateEnd: convertFormDateValueToKnmDataDate(item.dateEnd || item.type?.dateEnd),
      links: item.links || null,
      flagProfvizit: typeof item.type?.flagProfvizit === 'boolean' ? item.type.flagProfvizit : null,
      lastConductedKnmDate: convertFormDateValueToKnmDataDate(item.lastConductedKnmDate),
      programAttachment: item.programAttachment || null,
      programNumber: item.programNumber || null,
      inspectionResults: item.reason?.inspectionResults,
    },
    order: item.order
      ? {
          ...item.order,
          date: convertFormDateValueToKnmDataDate(item.order.date) || '',
          checkBeginDate: convertFormDateValueToKnmDataDate(item.order.checkBeginDate) || '',
          checkEndDate: convertFormDateValueToKnmDataDate(item.order.checkEndDate) || '',
        }
      : null,
    riskIndicators:
      item.riskIndicators?.map(x => ({
        guid: x.guid,
        indicatorRiskAttachment: convertKnmDocumentAttachmentsFormValuesToKnmData(x.indicatorRiskAttachment),
        indicatorRiskAuto: x.indicatorRiskAuto || null,
        riskIndicator: x.riskIndicator?.value || null,
        isNew: x.isNew,
      })) || null,
    numGuid: item.numGuid || item.listId || null,
    dateCreate: item.dateCreate || null,
  }));
};
